// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"355":"18457105","2937":"18457105","4187":"18457105","4826":"18457105","6597":"bb979365","8728":"18457105","9481":"18457105"}[chunkId] + ".chunk.css";
};